import { DEFAULT_CONSOLE_URL, DEFAULT_SITE_URL } from '@latisent/brand/constants';

/**
 * Cross-app URLs. Every link from the console to the marketing site goes
 * through here, never an inline env ternary. Set VITE_SITE_URL (and
 * VITE_CONSOLE_URL) in render.yaml when a custom domain is attached.
 */
export const SITE_URL = stripTrailingSlash(import.meta.env.VITE_SITE_URL ?? DEFAULT_SITE_URL);
export const CONSOLE_URL = stripTrailingSlash(import.meta.env.VITE_CONSOLE_URL ?? DEFAULT_CONSOLE_URL);

/** Absolute URL on the marketing site, e.g. `siteUrl('/support/')`. */
export function siteUrl(path = '/'): string {
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

function stripTrailingSlash(url: string): string {
  return url.endsWith('/') ? url.slice(0, -1) : url;
}
